'use strict';

import _ from 'lodash';

import './LegacyForm.less';

const ValidatedInput = require('./ValidatedInput');
const CKError = require('ck-core/source/classes/Error');
const CKImage = require('./image');
const Verifier = require('ck-core/source/system/Verifier');
const Button = require('./Button');
const EventContrib = require('ck-core/source/system/EventContrib');
const Component = require('./Component');

const Form = (module.exports = Component.define(EventContrib(), {
	init_Form: function(options) {
		this.options = options = _.defaults(options || {}, {
			image: null,
			buttons: [],
			submitButton: new Button('Submit', 'submit'),
			submit: 'submit',
			fields: [],
			radioGroup: null,
			initialValues: null,
			bootstrap: Form.BOOTSTRAP_NONE,

			requiredValidity: Verifier.STATUS.VALID,
			radioSelectRequired: false,

			// Reset the Form elements this many ms after a successful submission
			resetAfterSubmitDoneDelay: null
		});

		this._validityListeners = [];

		this.fields = {};
		this.groups = {};

		if (options.initialValues) {
			this.initialValues = options.initialValues;
			_.each(options.elements, element => {
				if (this.initialValues[element.name] !== undefined) {
					element.elementValue = this.initialValues[element.name];
				}
			});
		}

		this.dom = $('<form action="" class="clearfix" autocomplete="on">');

		// Auto-submit on enter behaviour
		if (options.submit) {
			this.dom.submit(event => {
				event.preventDefault();

				if (this.disabled) {
					return;
				}
				this.dom.find('.button[href="#' + options.submit + '"]').trigger('tap');
			});
		}

		if (options.image) {
			this.image = CKImage(options.image).appendTo(this.dom);
		}

		this.buttonWrapper = $('<div class="buttonWrapper">');

		this.buttonWrapper.appendTo(this.dom);

		this.submitButton = options.submitButton;

		_.each([...options.buttons, options.submitButton], button => {
			if (button) {
				this.buttonWrapper.append(button.dom);
			}
		});

		_.each(options.elements, this.addElement.bind(this));
		if (options.submit) {
			// Default submit option

			this.dom.append($('<input type="submit">').hide());
		}
	},
	addElement: function(element) {
		let options = this.options;

		const addValidatedInput = (input, element) => {
			input.form = this;

			this.fields[element.name] = input;

			if (element.group) {
				if (!this.groups[element.group]) {
					this.groups[element.group] = [];
				}

				this.groups[element.group].push(input);
			}

			if (options.bootstrap && input.getBootstrapDom) {
				this.buttonWrapper.before(input.getBootstrapDom(options.bootstrap));
			} else {
				this.buttonWrapper.before(input.dom);
			}

			if (input.radioGroup || input.options.activeWhen) {
				const updateInputVisibility = () => {
					if (!input.isActive()) {
						if (input.options.hideWhenInactive) {
							if (options.bootstrap && input.getBootstrapDom) {
								input.getBootstrapDom().hide();
							} else {
								input.dom.hide();
							}
						} else if (input.options.disableWhenInactive) {
							input.setEnabled(false);
						}
					} else {
						if (input.options.hideWhenInactive) {
							if (options.bootstrap && input.getBootstrapDom) {
								input.getBootstrapDom().show();
							} else {
								input.dom.show();
							}
						} else if (input.options.disableWhenInactive) {
							input.setEnabled(true);
						}
					}
				};

				this.subscribe('update', updateInputVisibility);

				updateInputVisibility();
			}

			this.addValidityListener(input);
		};

		var input;
		if (_.isPlainObject(element)) {
			if (!element.noLabel) {
				if (!options.lang || !_.isString(options.lang[element.name])) {
					CK.logger.error(
						new CKError({
							message: 'No lang for Form element',
							tags: {
								name: element.name
							}
						})
					);
				} else {
					element.label = options.lang[element.name];
				}
			}

			if (element.elementType === 'comment') {
				this.buttonWrapper.before(element.label);

				return;
			}

			input = new ValidatedInput(element);

			addValidatedInput(input, element);
		} else if (ValidatedInput.isInstance(element)) {
			addValidatedInput(element, element);
		} else {
			this.buttonWrapper.before(element);
		}

		return input || element;
	},
	addValidityListener: function(input) {
		if (!this.options.requiredValidity) {
			return;
		}

		if (!this.options.submitButton) {
			CK.logger.warn('Cannot use requiredValidity with no submitButton');
		}

		const listener = {
			source: input,

			event: 'verify',

			handler: () => {
				var allFieldsValid = _.every(this.fields, field => {
					if (ValidatedInput.isInstance(field)) {
						const isValid = field.validityIsAtLeast(this.options.requiredValidity);

						if (isValid) {
							return isValid;
						} else {
							CK.logger.debug('Field is invalid', field);
						}
					} else {
						return true;
					}
				});
				if (this.options.radioSelectRequired) {
					// Ensure that all groups of radio buttons have a button selected
					_.each(this.groups, group => {
						var anySelected = _.some(group, element => {
							return element.getValue();
						});

						if (!anySelected) {
							allFieldsValid = false;
						}
					});
				}
				if (allFieldsValid) {
					this.enable();
				} else {
					this.disable();
				}
			}
		};

		this._validityListeners.push(listener);

		listener.source.subscribe(listener.event, listener.handler);

		if (input.validate && this.options.requiredValidity === Verifier.STATUS.VALID) {
			input.onChange(true);
		}
	},

	init_resetAfterSubmitDone: function() {
		if (!this.options.resetAfterSubmitDoneDelay) {
			return;
		}

		if (!this.options.submitButton) {
			CK.logger.warn('Cannot use resetAfterSubmitDoneDelay with no submitButton');
		}

		this.options.submitButton.subscribe(Button.STATUS.SUCCESS, () => {
			setTimeout(() => {
				if (!this.dom) {
					return;
				}

				this.dom[0].reset();

				this.options.submitButton.enable();
			}, this.options.resetAfterSubmitDoneDelay);
		});
	},

	cleanup_validityListeners: function() {
		_.each(this._validityListeners, listener => {
			listener.source.unsubscribe(listener.event, listener.handler);
		});
		this._validityListeners = [];
	},
	disable: function() {
		this.disabled = true;

		this.submitButton && this.submitButton.disable();

		this.publish(Form.EVENTS.DISABLE);
	},

	enable: function() {
		this.disabled = false;

		this.submitButton && this.submitButton.enable();

		this.publish(Form.EVENTS.ENABLE);
	},

	getValue: function() {
		return _.defaults(
			_.mapValues(this.fields, field => {
				if (field && field.getValue) {
					return field.getValue();
				} else {
					return field;
				}
			}),
			this.initialValues
		);
	},

	getChangedValues: function() {
		var output = {};

		_.each(this.fields, (field, name) => {
			if (field.hasChanged()) {
				output[name] = field.getValue();
			}
		});

		return output;
	},

	setGroupValue: function(groupName, groupValue) {
		this.fields[groupName] = groupValue;

		_.each(this.fields, (field, name) => {
			if (field.group === groupName && field.elementType === ValidatedInput.ELEMENT_TYPES.RADIO) {
				if (groupValue === name) {
					field.setValue(true);
				} else {
					field.setValue(false);
				}
			}
		});
	},

	type: 'Form'
}));
Form.BOOTSTRAP_NONE = false;

Form.BOOTSTRAP_47 = {
	offset: 0,
	labelColumnSize: 4,
	inputColumnSize: 7
};
Form.BOOTSTRAP_48 = {
	offset: 0,
	labelColumnSize: 4,
	inputColumnSize: 8
};
Form.BOOTSTRAP_DEFAULT = {};

Form.EVENTS = {
	ENABLE: 'enable',
	DISABLE: 'disable'
};
